import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class MatchEventsModuleTerms extends BaseTerms {
  GAME_HIGHLIGHTS = "Match Events";
  GC_MAJOR_EVENTS = "Top";
  WEB_GC_GAME_EVENTS_NO_EVENTS = "No Events";
  WEB_GC_GAME_EVENTS_NO_TOP_EVENTS = "No Top Events";
  WEB_GAME_CENTER_FROM_THE_BENCH = "From the bench";
}
